import {BaseContainerModel} from '../../base-container.model';
import {bl_aat_claim_cycle_review_setting_RowClass} from '../../../dbschema';

export class ClaimCycleReviewSettingContainerModel extends BaseContainerModel {
  bl_aat_claim_cycle_review_setting: bl_aat_claim_cycle_review_setting_RowClass = new bl_aat_claim_cycle_review_setting_RowClass();
}
